import { IdentityProviderType } from "Api/Api";
import RacketImage from "Assets/Images/racket.png";
import { UnauthenticatedLayout } from "Components/Layout/UnauthenticatedLayout";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { signInAsync } from "State/Auth/AuthReducer";
import { RootStateType } from "State/Store";
import { Resources, useResource } from "Translations/Resources";
import styled from "styled-components";

const StyledImg = styled.div`
  img {
    width: auto;
    height: 405px;
    animation: racketStart 1s infinite linear;
  }
  @media (max-width: 730px) {
    img {
      width: auto;
      height: 220px;
      margin-bottom: 16px;
    }
  }

  @keyframes racketStart {
    0% {
      transform: rotate(0deg) translate(0px, 0px);
    }
    10% {
      transform: rotate(1deg) translate(1px, 1px);
    }
    20% {
      transform: rotate(0deg) translate(1px, 3px);
    }
    30% {
      transform: rotate(-1deg) translate(0px, 0px);
    }
    40% {
      transform: rotate(-2deg) translate(2px, -1px);
    }
    50% {
      transform: rotate(-1deg) translate(0px, 0px);
    }
    60% {
      transform: rotate(0deg) translate(1px, 1px);
    }
    70% {
      transform: rotate(1deg) translate(0px, 0px);
    }
    80% {
      transform: rotate(0deg) translate(2px, -1px);
    }
    90% {
      transform: rotate(-1deg) translate(0px, 0px);
    }
    100% {
      transform: rotate(0deg) translate(0px, 0px);
    }
  }
`;

export const GoogleRedirectPage: React.FunctionComponent = _ => {
  const { t } = useResource();
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { isLoading, user } = useSelector((e: RootStateType) => e.auth);

  const code = new URLSearchParams(location.search).get("code") || "";

  React.useEffect(() => {
    dispatch(
      signInAsync.request({
        authCode: code,
        identityProvider: IdentityProviderType.Google,
      }),
    );
  }, [code, dispatch]);

  React.useEffect(() => {
    if (!isLoading && !!user) {
      history.push(`/${t(Resources.Routes.Dashboard)}`);
    }
  }, [isLoading, user, history, t]);

  return (
    <UnauthenticatedLayout
      title={t(Resources.Auth.Google.Redirect.Title)}
      subTitle={t(Resources.Auth.Google.Redirect.SubTitle)}
      image={
        <StyledImg>
          <img src={RacketImage} alt={""} />
        </StyledImg>
      }
    ></UnauthenticatedLayout>
  );
};
